import { useQuery } from '@tanstack/react-query';

import { getToursCommandCentre } from '~/services/ReportingService';

import { toursCommandCentreQueryKeys } from './toursCommandCentreQueryKeys';

export function useGetToursCommandCentre(enabled = true) {
  return useQuery({
    queryKey: toursCommandCentreQueryKeys.all,
    queryFn: ({ signal }) => getToursCommandCentre({ signal }),
    staleTime: 60 * 60 * 1000,
    retry: false,
    enabled,
  });
}
